import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';
import NextPage from '../../components/NextPage/NextPage';

class PageCustomFabrication extends Component {

  render() {
    return (
        <Page primaryTitle="Displays" secondaryTitle="Custom Fabrication" section="displays">
            <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 pageDesign">
                <p className="intro">If you need something unique, we can design, engineer and build just about anything for you!</p>

                <h3>Custom Counter</h3>

                <div className="custom-box">
                    <div className="row">
                        <div className="col-sm-7">
                            <img className="fluid" src="/images/custom/wards-science-counter-1.jpg" alt="custom counter"/>
                        </div>
                        <div className="col-sm-5">
                            <p>This custom built counter provides plenty of locking storage space, and also features ample recessed literature shelves at both ends. A floating counter top on standoffs, and a laser cut company logo gives the counter a clean and modern look.</p>
                            <img className="fluid" src="/images/custom/wards-science-counter-2.jpg" alt="custom counter back"/>
                        </div>
                    </div>
                </div>

                <h3>Clever Kiosks</h3>

                <div className="custom-box">
                    <div className="row">
                        <div className="col-sm-6">
                            <img className="fluid" src="/images/custom/vwr-custom-kiosk-1.jpg" alt="custom kiosk"/>
                        </div>
                        <div className="col-sm-6">
                            <p>This flexible kiosk system was designed to allow single units to be connected together back-to-back, or in a triangle configuration, allowing them to make the best use of any available exhibit space. Locking cabinets keep the electronics safe.</p>
                            <img className="fluid" src="/images/custom/vwr-custom-kiosk-2.jpg" alt="custom kiosks"/>
                        </div>
                    </div>
                </div>

                <h3>Multi-Level Counter</h3>

                <div className="custom-box">
                    <div className="row">
                        <div className="col-sm-12">
                            <img className="fluid" src="/images/custom/aerzen-custom-counter.jpg" alt="custom counter"/>
                        </div>
                        <div className="col-sm-12">
                            <p>This triple custom counter system can be separated into 3 individual couters, or combined to form a multi-level workspace with tons of locking storage.</p>
                        </div>
                    </div>
                </div>
                
                <h3>Not your average TV stand!</h3>

                <div className="custom-box">
                    <div className="row">
                        <div className="col-sm-6">
                            <img className="fluid" src="/images/custom/prod_tv_stand_lg.jpg" alt="custom monitor stand"/>
                        </div>
                        <div className="col-sm-6">
                            <p>We designed and built this custom monitor stand which securely holds a 70" TV and features hidden casters for easy transport, sustainable bamboo countertop, adjustable height on the TV mount, and a secure locking door and internal shelf for the electronics.</p>
                        </div>
                    </div>
                </div>

                <NextPage page={this.props.page}/>

            </div>
            <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
                <SideImage page={this.props.page} />
            </aside>
        </Page>
    );
  }
}

export default PageCustomFabrication;



// WEBPACK FOOTER //
// ./src/pages/PageCustomFabrication/PageCustomFabrication.js